// extracted by mini-css-extract-plugin
export var title = "styles-module--title--2SKB7";
export var text = "styles-module--text--3pkjd";
export var promotion = "styles-module--promotion--2ty0O";
export var form = "styles-module--form--37IGu";
export var formControls = "styles-module--form-controls--Hicl5";
export var button = "styles-module--button--1dG59";
export var formMessage = "styles-module--form-message--l9NCw";